import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class ResponsiveService {
	public media$: BehaviorSubject<any>;
	public resizeSubscription: Subscription;

	constructor() {
		this.init();
		this.media$ = new BehaviorSubject(true);
	}

	init() {
		// Check if window is available (for SSR compatibility)
		if (typeof window === 'undefined') {
			return;
		}

		this.resizeSubscription = fromEvent(window, 'resize')
			.pipe(debounceTime(250))
			.subscribe((event) => {
				const width = this.getWindowWidth(event);
				if (width !== null) {
					this.media$.next(this.mediaBreakpoint(width));
				}
			});

		this.resizeSubscription = fromEvent(window, 'load').subscribe((event) => {
			const width = this.getWindowWidth(event);
			if (width !== null) {
				this.media$.next(this.mediaBreakpoint(width));
			}
		});
	}

	private getWindowWidth(event: any): number | null {
		// Try to get width from event.currentTarget first
		if (event?.['currentTarget'] && (event['currentTarget'] as Window).innerWidth != null) {
			return (event['currentTarget'] as Window).innerWidth;
		}
		// Fallback to window.innerWidth
		if (typeof window !== 'undefined' && window.innerWidth != null) {
			return window.innerWidth;
		}
		return null;
	}

	get media() {
		return this.media$.value;
	}

	mediaBreakpoint(w: number): any {
		let size = 'xs';
		let m = true;
		let width = w;
		if (w >= 1200) {
			size = 'xl';
			m = false;
		} else if (w >= 992) {
			size = 'lg';
			m = false;
		} else if (w >= 768) {
			size = 'md';
			m = true;
		} else if (w >= 556) {
			size = 'sm';
			m = true;
		} else if (w >= 576) {
			size = 'xs';
			m = true;
		}
		return { is_mobile: m, size: size, width: width };
	}
}
